export default __webpack_public_path__ + "static/media/The_Vanitie_50x70.9ef58071.jpg";